import React from 'react'
import { graphql, useFragment } from 'react-relay'

import { buildSocialLinks, SocialProfileLinksRow } from './SocialProfileLinks'

import { UserSocialProfileLinks_user$key } from './__generated__/UserSocialProfileLinks_user.graphql'

export const UserSocialProfileLinks = ({
  user,
  size = '$4',
}: {
  user: UserSocialProfileLinks_user$key
  size?: '$4' | '$5'
}) => {
  const data = useFragment(
    graphql`
      fragment UserSocialProfileLinks_user on User {
        websiteUrl
        twitterUrl
        instagramUrl
        linkedinUrl
        youtubeUrl
        githubUrl
        blueskyUrl
      }
    `,
    user
  )

  return <SocialProfileLinksRow links={buildSocialLinks(data)} size={size} />
}
